import { useIsMutating } from '@tanstack/react-query';

import { fleetQuotationsKeys } from '../../query-keys';

export const fleetMutationKey = [...fleetQuotationsKeys.all, 'mutation'] as const;

/**
 * Browser-local serialization prevents independent fleet components from
 * issuing overlapping writes while the server enforces the same invariant.
 */
export const fleetMutationDefaults = {
  mutationKey: fleetMutationKey,
  scope: { id: 'fleet-quotation-writes' },
} as const;

function mutationFleetId(variables: unknown): string | null {
  if (typeof variables !== 'object' || variables === null || !('fleetId' in variables)) return null;
  const fleetId = (variables as { fleetId?: unknown }).fleetId;
  return typeof fleetId === 'string' ? fleetId : null;
}

export function useFleetMutationCount(fleetId: string | null | undefined): number {
  return useIsMutating({
    mutationKey: fleetMutationKey,
    predicate: (mutation) =>
      Boolean(fleetId) && mutationFleetId(mutation.state.variables) === fleetId,
  });
}
